module.exports = __webpack_public_path__ + "static/media/icon_32.0eee59ce.svg";